import { createFileRoute } from '@tanstack/react-router'
import { useCallback } from 'react'
import { ModelsPage, parseModelListSearch, type ModelListSearch } from '@/features/model-registry'

declare module '@tanstack/react-router' {
  interface HistoryState {
    /** List state of the Models page the user came from; the Models tab returns to it. */
    modelList?: ModelListSearch
  }
}

export const Route = createFileRoute('/app/model-registry/models')({
  validateSearch: parseModelListSearch,
  component: ModelsRoute,
})

function ModelsRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  // Stable: the page also calls it from an effect (back to the last page that has models).
  const onSearchChange = useCallback(
    (patch: Partial<ModelListSearch>) => {
      void navigate({ search: (previous) => ({ ...previous, ...patch }), replace: true })
    },
    [navigate],
  )
  return (
    <ModelsPage
      search={search}
      onSearchChange={onSearchChange}
      onOpen={(model, page) => {
        void navigate({
          to:
            page === 'evaluation'
              ? '/app/model-registry/models/$modelId/evaluation'
              : '/app/model-registry/models/$modelId/experiment',
          params: { modelId: model.id },
          // The Models tab of that page returns to this search, filter, sort, page and view.
          state: { modelList: search },
        })
      }}
    />
  )
}
